import { string, object } from "prop-types"

const SectionHeader = ({ title, buttonText, buttonAttrs = null }) => {
  return (
    <div className="d-f ai-c jc-sb mb-2 d-n@print">
      <h4 className="mb-0 fw-600">{title}</h4>
      <div className="d-f" style={{ gap: "0.5rem" }}>
        {buttonAttrs && (
          <button className="btn-outline xs" {...buttonAttrs}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  )
}

SectionHeader.propTypes = {
  title: string.isRequired,
  buttonText: string.isRequired,
  buttonAttrs: object
}

export default SectionHeader
